import React, { useEffect, useState } from "react";
import {
  Card,
  PrimaryButton,
  IconSales,
  withTooltip,
  TOOLTIP_HORIZONTAL_ALIGNMENTS,
  TOOLTIP_VERTICAL_ALIGNMENTS,
  THEMES,
  Divider,
  Dialog,
  Radio,
  TextButton,
} from "cdk-radial";
import { BundleCardTitle, BundleCardApiList } from "./Bundle";
import { useAPIDirectoryHomeContext } from "../../../../contexts/APIHomeDirectoryContext";
import replaceAll from "string.prototype.replaceall";
import { PrivateIcon } from "../../../common/icons/icons";

import {
  API_DIRECTORY_THEME,
  API_VISIBILITY,
  BUNDLE_TYPE,
  CONTRACT_TEXT,
} from "../../../../utils/constants";
import { BUILD_WITH_BUNDLES } from "../../constants";

const BTN_TEXT = {
  ADD_TO_CART: "Add to Cart",
  ADDED_TO_CART: "Added to Cart",
  VIEW_IN_MY_APIS: "View in My APIs",
};

function suppressMarkdown(input = "") {
  return replaceAll(input, "#", "");
}

const ContractIcon = () => {
  const compwithToolTip = (props) => {
    return <IconSales {...props} className="api-dir-pkg_icons" />;
  };

  const Component = withTooltip(compwithToolTip, {
    id: `contract-icon`,
    text: CONTRACT_TEXT,
    theme: THEMES.LIGHT,
  });
  return (
    <Component
      horizontalAlignment={TOOLTIP_HORIZONTAL_ALIGNMENTS.RIGHT}
      verticalAlignment={TOOLTIP_VERTICAL_ALIGNMENTS.TOP}
    />
  );
};

const BundleCard = (props) => {
  const {
    apiBundle: {
      apis,
      id: bundleId,
      name,
      description,
      isContracted,
      visibility,
    },
    existingSolutionDetails,
    disableBuildNow,
    isMsaConsented,
  } = props;

  const {
    belongsTo,
    cartDetails,
    orderDetails,
    apiHomeOnClickHandlers,
    requestStatus,
  } = useAPIDirectoryHomeContext();

  const isDealerFlow = belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY;
  const isISVFlow = belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY;

  const requestProcessing =
    (requestStatus && requestStatus[bundleId]?.isLoading) || false;

  const allOrderedAPIs = [
    ...(orderDetails?.restApis || []),
    ...(orderDetails?.asyncApis || []),
  ];

  const cartApiIds = new Set(cartDetails?.map((item) => item.resourceId) || []);
  const orderApiIds = new Set(allOrderedAPIs.map((item) => item.id));

  const isAddedInCart = apis && apis.every((api) => cartApiIds.has(api.id));
  const isBundleAddedInCart =
    apis &&
    apis.every((api) => cartApiIds.has(api.id) || cartApiIds.has(bundleId));
  const isPurchased = apis && apis.every((api) => orderApiIds.has(api.id));
  const isBundleContracted = isContracted;

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedRadio, setSelectedRadio] = useState([]);
  const getDescription = () => {
    if (!!description) {
      return suppressMarkdown(description);
    }
  };
  let setBundleApis = "";
  if (apis) {
    apis.forEach((api, index) => {
      setBundleApis += api.id;
      if (apis.length - 1 !== index) {
        setBundleApis += ",";
      }
    });
  }

  const buildWithBundles = () => {
    if (selectedRadio === BUILD_WITH_BUNDLES.NEW_APP) {
      apiHomeOnClickHandlers.buildWithBundle({
        appId: selectedRadio?.id,
        buildWithType: BUILD_WITH_BUNDLES.NEW_APP,
        bundleId,
      });
    } else {
      apiHomeOnClickHandlers.buildWithBundle({
        appId: selectedRadio?.id,
        buildWithType: BUILD_WITH_BUNDLES.EDIT_APP,
        bundleId,
      });
    }
    setIsDialogOpen(false);
  };

  const showContractIcon = isContracted;

  const handleBuildNow = (e) => {
    e.stopPropagation();
    if (existingSolutionDetails.length === 0) {
      apiHomeOnClickHandlers.buildWithBundle({
        appId: selectedRadio?.id,
        buildWithType: BUILD_WITH_BUNDLES.NEW_APP,
        bundleId,
      });
    } else {
      setIsDialogOpen(true);
    }
  };
  const handleAddBundleIntoCart = (e) => {
    e.stopPropagation();
    const cartApiIds = new Set(
      cartDetails?.map((item) => item.resourceId) || [],
    );
    const allOrderedAPIs = [
      ...(orderDetails?.restApis || []),
      ...(orderDetails?.asyncApis || []),
    ];
    const orderApiIds = new Set(allOrderedAPIs.map((item) => item.id));
    const filteredApis = apis.filter(
      (api) => !cartApiIds.has(api.id) && !orderApiIds.has(api.id),
    );

    const isPriceBundle =
      props?.apiBundle?.plans?.length > 0 &&
      props?.apiBundle?.terms?.length > 0;

    if (isPriceBundle) {
      apiHomeOnClickHandlers.addBundleIntoCart({
        bundleId: bundleId,
        bundleType: BUNDLE_TYPE.PRICE,
        cart: (filteredApis || [])?.map((api) => ({
          resourceId: api?.id,
          resourceType: api?.type,
        })),
      });
    } else {
      apiHomeOnClickHandlers.addBundleIntoCart({
        bundleId: bundleId,
        cart: (filteredApis || [])?.map((api) => ({
          resourceId: api?.id,
          resourceType: api?.type,
        })),
      });
    }
  };

  const handleViewInMyAPIs = (event) => {
    event.stopPropagation();
    if (event.target.innerText === BTN_TEXT.VIEW_IN_MY_APIS)
      apiHomeOnClickHandlers.viewInMyAPIs({
        bundleId,
        btn: BTN_TEXT.VIEW_IN_MY_APIS,
      });
  };
  const handleCardClick = () => {
    if (apiHomeOnClickHandlers?.viewBundleDetails && props?.apiBundle) {
      apiHomeOnClickHandlers.viewBundleDetails({
        bundleDetails: props.apiBundle,
      });
    }
  };

  return !name && !description && !apis ? null : (
    <>
      <Card
        data-cy={`spec-card__${name}`}
        className="api-dir-pkg_bundle_spec-card"
        dataTestId="bundle_card"
        onClick={handleCardClick}
        style={{ cursor: "pointer" }}
      >
        <div className="api-dir-pkg_bundle_card_top_div">
          <div className="api-dir-pkg_bundle_title_icon_wrapper">
            <BundleCardTitle name={name} />
            <div className="api-dir-pkg_bundle_icons_wrapper ">
              {visibility === API_VISIBILITY.PRIVATE && <PrivateIcon />}
              {showContractIcon && <ContractIcon />}
            </div>
          </div>
          <div className="api-dir-pkg_bundle_card_description">
            {getDescription()}
          </div>
          <div className="api-dir-pkg_list_apis">
            Included APIs ({(apis || []).length || 0})
          </div>
        </div>
        <BundleCardApiList apis={apis} belongsTo={belongsTo} />
        <div className="api-dir-pkg_bundle_card_bottom_div">
          <div
            style={{ marginLeft: isISVFlow ? "auto" : "", marginTop: "24px" }}
          >
            {isDealerFlow ? (
              isPurchased ? (
                <TextButton
                  dataTestId="text-button"
                  style={{ width: "100%" }}
                  onClick={handleViewInMyAPIs}
                  size="standard"
                  text="View in My APIs"
                />
              ) : (
                !isContracted && (
                  <PrimaryButton
                    dataTestId="add_bundle_into_cart"
                    iconColor="primary"
                    text={
                      isAddedInCart || isBundleAddedInCart
                        ? "Added to Cart"
                        : "Add to Cart"
                    }
                    onClick={handleAddBundleIntoCart}
                    style={{ width: "100%" }}
                    className={
                      isAddedInCart || isBundleAddedInCart
                        ? "api-dir-pkg_added-to-cart-bundle-btn"
                        : ""
                    }
                    isDisabled={
                      isAddedInCart || isBundleAddedInCart || !isMsaConsented
                    }
                    isLoading={requestProcessing}
                  />
                )
              )
            ) : null}
            {isISVFlow && (
              <>
                <Divider></Divider>
                <PrimaryButton
                  className="build_with_bundle_button"
                  dataTestId="build_with_bundle"
                  iconColor="primary"
                  text="Build Now"
                  onClick={handleBuildNow}
                  isDisabled={disableBuildNow}
                />
              </>
            )}
            <Dialog
              buttonsProps={[
                {
                  id: "dialog-action-1",
                  onClick: buildWithBundles,
                  text: "Continue",
                  variant: "text",
                  isDisabled: selectedRadio.length === 0,
                },
              ]}
              dataTestId="sbdialog"
              isOpen={isDialogOpen}
              id="sbdialog"
              onClose={() => {
                setIsDialogOpen(false);
                setSelectedRadio([]);
              }}
              onClick={(e) => e.stopPropagation()}
              title="Build Now"
            >
              <div className="api-dir-pkg_dialog_bundle_card">
                <div style={{ marginLeft: "-16px" }}>
                  <Radio
                    dataTestId="radioNewApp"
                    id="radioNewApp"
                    label={
                      <span>
                        Build a new App with <strong>{name}</strong>
                      </span>
                    }
                    labelPosition="after"
                    checked={selectedRadio === BUILD_WITH_BUNDLES.NEW_APP}
                    name="radio"
                    onChange={() =>
                      setSelectedRadio(BUILD_WITH_BUNDLES.NEW_APP)
                    }
                    size="standard"
                    value="newApp"
                  />
                </div>
                {existingSolutionDetails?.length > 0 && (
                  <>
                    <Divider />
                    <div className="api-dir-pkg_select_existing_apps">
                      Select an existing App to add the {name}
                    </div>
                    {existingSolutionDetails?.map((app, index) => {
                      return (
                        <div
                          className="api-dir-pkg_radio_app_names_list"
                          style={{ marginLeft: "-16px" }}
                        >
                          <Radio
                            dataTestId={`radio-${index}`}
                            id={`radio-${index}`}
                            label={
                              <div>
                                <strong>{app.displayName}</strong>
                              </div>
                            }
                            labelPosition="after"
                            name="radio"
                            checked={selectedRadio === app}
                            onChange={() => setSelectedRadio(app)}
                            size="standard"
                            value={app}
                          />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </Dialog>
          </div>
        </div>
      </Card>
    </>
  );
};

export default BundleCard;
